var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.483,
    height: 24,
    viewBox: "0 0 42.483 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21975",
    "data-name": "Group 21975",
    transform: "translate(0 -12.679)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5524",
    "data-name": "Rectangle 5524",
    width: 24,
    height: 4,
    rx: 2,
    transform: "translate(18.483 12.679)",
    fill: "#9b2690"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72711",
    "data-name": "Path 72711",
    d: "M2,0H24.483a2,2,0,0,1,0,4H2A2,2,0,0,1,2,0Z",
    transform: "translate(9 22.679)",
    fill: "#9b2690"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5525",
    "data-name": "Rectangle 5525",
    width: 24,
    height: 4,
    rx: 2,
    transform: "translate(0 32.679)",
    fill: "#9b2690"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.1daca7e3c807260b43edc6a00a38b24b.svg";
export { ForwardRef as ReactComponent };